import { h, render, Component } from 'preact';
import FilterItemChoice from './FilterItemChoice';
import FilterItemInterval from './FilterItemInterval';
import FilterItemBoolean from './FilterItemBoolean';
import FilterItemRange from './FilterItemRange';
import { observer } from 'mobx-react';
import SharedFiltersStore from './store/SharedFiltersStore';

export default observer(
    class FilterItem extends Component {

        constructor(props) {
            super(props);



            this.sharedStateProps = {};
            if (props.sharedFilterId) {
                this.sharedStateProps = {
                    sharedState: SharedFiltersStore.getStatusByFilterId(props.sharedFilterId),
                }
            }
        }

        render() {
            const props = this.props;

            if(props.kind === 'choice') {
                return (
                    <FilterItemChoice
                        id={props.propertyId}
                        title={props.title}
                        choices={props.choices}
                        onChange={props.onChange}
                        {...this.sharedStateProps}
                        />
                );
            }
            else if(props.kind === 'intervals') {
                return (
                    <FilterItemInterval
                        id={props.propertyId}
                        title={props.title}
                        intervals={props.intervals}
                        onChange={props.onChange}
                        {...this.sharedStateProps}
                        />
                )
            }
            else if(props.kind === 'range') {
                return (
                    <FilterItemRange
                        id={props.propertyId}
                        title={props.title}
                        minTitle={props.minTitle}
                        minValue={props.minValue}
                        maxTitle={props.maxTitle}
                        maxValue={props.maxValue}
                        onChange={props.onChange}
                        {...this.sharedStateProps}
                        />
                )
            }
            else if(props.kind === 'boolean') {
                return (
                    <FilterItemBoolean
                        id={props.propertyId}
                        title={props.title}
                        onChange={props.onChange}
                        {...this.sharedStateProps}
                        />
                )
            }

            return null;
        }
    }
);
